import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaSelectThemeSavePage } from './plaza-select-theme-save';

@NgModule({
  declarations: [
    PlazaSelectThemeSavePage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaSelectThemeSavePage),
    TranslateModule.forChild()
  ],
})
export class PlazaSelectThemeSavePageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-theme-save/plaza-select-theme-save.module.ts